import React from 'react'
import ErrorMessage from "../../plateform/recruiter/components/ErrorMessage"

const Input = ({
  label, 
  type = 'text', 
  name, 
  value, 
  placeholder, 
  onChange, 
  required = false, 
  className = '',
  classContainer=" mb-2 ",
  textSize ="text-sm",
  error,
  ...props
}) => {
  return (
    <div className={""+classContainer}>
      {label && (
        <label 
          htmlFor={name} 
          className={`block mb-2 ${textSize} font-medium text-gray-900 text-start`}
        >
          {label}
        </label>
      )}
      <input
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        required={required}
        className={` border border-gray-300 text-gray-900 ${textSize} rounded-lg outline-none focus:ring-2 focus:ring-gray-100/20  block w-full p-2.5   ${className}`}
        {...props}
      />
      {/* {error && <p className="text-red-500">{error}</p>} */}
      <ErrorMessage message={error}/>
    </div>
  )
}

export default Input
